import { render, staticRenderFns } from "./EntitlementsObligations.vue?vue&type=template&id=3f9cf4b2&scoped=true&"
import script from "./EntitlementsObligations.vue?vue&type=script&lang=js&"
export * from "./EntitlementsObligations.vue?vue&type=script&lang=js&"
import style0 from "./EntitlementsObligations.vue?vue&type=style&index=0&id=3f9cf4b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9cf4b2",
  null
  
)

export default component.exports